import { GameId } from '@common'
import { SCIDApplication } from '@common/models/scid'
import { useTranslations } from 'next-intl'

const getGameProgressCopyKeys = (game: GameId) => {
  switch (game) {
    case 'clashofclans': {
      return ['acc_th', 'acc_trophies'] as const
    }
    case 'hayday': {
      return ['acc_farmlevel'] as const
    }
    case 'brawlstars': {
      return ['acc_explevel', 'acc_trophies'] as const
    }
    case 'clashroyale': {
      return ['acc_arenalevel', 'acc_trophies'] as const
    }
    case 'squadbusters':
      return null
  }
}

export const GameProgress = ({
  application,
  account,
}: {
  application: SCIDApplication['application']
  account: SCIDApplication['account']
}) => {
  const t = useTranslations()
  const copyKeys = getGameProgressCopyKeys(application)

  if (!copyKeys) {
    return null
  }

  return (
    <>
      {copyKeys.map((key, idx) => {
        return account?.progress?.[idx] && <span key={idx}>{`${key ? t(key) : ''} ${account?.progress?.[idx]}`}</span>
      })}
    </>
  )
}
